<template>
    <div id="menu-setting" style="height:150px" class="offcanvas offcanvas-bottom offcanvas-detached rounded-m overflow-hidden">
        <div class="content">
            <div class="form-check form-check-custom">
                <input class="form-check-input" type="checkbox" value="" id="terjemahan_bait" name="terjemahan_bait" v-model="t_terjemahan_bait">
                <label class="form-check-label" for="terjemahan_bait">Terjemahan Bait</label>
                <i class="is-checked color-green-dark bi bi-check-square"></i>
                <i class="is-unchecked color-red-dark bi bi-x-square"></i>
            </div>
            <div class="form-check form-check-custom">
                <input class="form-check-input" type="checkbox" value="" id="terjemahan_kata" name="terjemahan_kata" v-model="t_terjemahan_kata">
                <label class="form-check-label" for="terjemahan_kata">Terjemahan Per Kata</label>
                <i class="is-checked color-green-dark bi bi-check-square"></i>
                <i class="is-unchecked color-red-dark bi bi-x-square"></i>
            </div>
            <div class="form-check form-check-custom">
                <input class="form-check-input" type="checkbox" value="" id="harokat" name="harokat" v-model="t_harokat">
                <label class="form-check-label" for="harokat">Harokat</label>
                <i class="is-checked color-green-dark bi bi-check-square"></i>
                <i class="is-unchecked color-red-dark bi bi-x-square"></i>
            </div>
            <div class="form-check form-check-custom">
                <input class="form-check-input" type="checkbox" value="" id="detail" name="detail" v-model="t_detail">
                <label class="form-check-label" for="detail">Detail</label>
                <i class="is-checked color-green-dark bi bi-check-square"></i>
                <i class="is-unchecked color-red-dark bi bi-x-square"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: 'Setting',
    data(){
        return {
            t_terjemahan_bait: false,
            t_terjemahan_kata: false,
            t_harokat: false,
            t_detail: false
        }
    },
    created() {
        this.t_terjemahan_bait = this.terjemahan_bait
        this.t_terjemahan_kata = this.terjemahan_kata
        this.t_harokat = this.harokat
        this.t_detail = this.detail
    },
    methods: {
        ...mapActions(["changeTerjemahanBait", "changeTerjemahanKata", "changeHarokat", "changeDetail"]),
    },
    computed: {
        ...mapState([
            'terjemahan_bait', 'terjemahan_kata', 'harokat', 'detail'
        ])
    },
    watch: {
        t_terjemahan_bait(value) {
            this.changeTerjemahanBait(value)
        },
        t_terjemahan_kata(value) {
            this.changeTerjemahanKata(value)
        },
        t_harokat(value) {
            this.changeHarokat(value)
        },
        t_detail(value) {
            this.changeDetail(value)
        }
    }
}
</script>